import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Button,  Grid } from 'react-bootstrap';
import ModuleHeader from '../../components/ModuleHeader';
import { userOperations } from "./state";
import { ADD_USER, EDIT_USER } from "./routes";
import TableTemplate from '../../components/TableTemplate';

class User extends Component {

    componentDidMount(){
        this.props.fetchDefault({businessPartnerCode: this.props.businessPartnerCode});
    }

    getUser = (data) => {
        if(undefined === data){                
            this.props.history.push(ADD_USER);
        }else{
            this.props.history.push(EDIT_USER+"/"+data.userCode);            
        }
    }

    render(){
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader title={"ユーザ一覧"}/>                    
                    <TableTemplate 
                        {...this.props}
                        rowButtons = {[
                            {
                                onClick: this.getUser,
                                icon: ['far', "edit"],
                                bsStyle: "link"
                            }
                        ]}
                    />
                    <br/>
                    <center>
                        <Button 
                            className="button-common"
                            onClick={()=>this.getUser()}
                        >
                            新規登録
                        </Button>
                    </center>           
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        businessPartnerCode: state.auth.credentials.riyo_kigyo_id,
        isAuthenticated: state.auth.isAuthenticated,
        tableHeader: state.user.tableHeader,
        tableList: state.user.list,
        tableColumns: state.user.tableColumns,
    }
};

const mapDispatchToProps = {
    fetchDefault: userOperations.fetchDefault,    
};

export default connect(mapStateToProps, mapDispatchToProps)(User);